import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetOverallOccupancyResponseDtoSchema = z.object({
  vacantBeds: z.number().nullable(),
  occupiedBeds: z.number().nullable(),
  occupancy: z.object({
    currentAvg: z.number().nullable(),
    changePct: z.number().nullable(),
  }),
});

const _GetOverallOccupancyRequestDtoSchema = z.object({
  from: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  to: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  facilitiesIds: z.array(z.number()).optional(),
});

export type GetOverallOccupancyRequestDto = z.infer<
  typeof _GetOverallOccupancyRequestDtoSchema
>;
export type GetOverallOccupancyResponseDto = z.infer<
  typeof GetOverallOccupancyResponseDtoSchema
>;

export const getOverallOccupancy = (
  params: GetOverallOccupancyRequestDto,
  config?: AxiosRequestConfig<GetOverallOccupancyRequestDto>
) => {
  return api
    .get('/facilities/overall-occupancy', { params, ...config })
    .then(responseContract(GetOverallOccupancyResponseDtoSchema));
};
